module.exports = __webpack_public_path__ + "static/media/DKAIR.e019576c.png";